<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>deBug查询</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search" style="align-items: center;">
            <div>
                <el-input placeholder="请输入查询条件" prefix-icon="el-icon-search" size="small" @keyup.enter.native="Query"
                    v-model="deBugCondition"></el-input>
            </div>
            <el-date-picker v-model="dateValue" type="date" placeholder="选择日期" clearable :picker-options="pickerOptions"
                @change="handleDateChange">
            </el-date-picker>
            <div style="margin-left: 20px;"> <el-button type="primary" size="small" @click.native="Query">查询</el-button>
            </div>
            <div style="margin-left:20px;"> <el-button type="success" size="small"
                    @click.native="resetting">重置</el-button>
            </div>
        </div>
        <div class="list" style="margin-top: 20px;">
            <el-table :data="deBugList" style="width: 100%" size="mini" stripe :row-class-name="tableRowClassName">
                <el-table-column prop="id" label="id" width="100"></el-table-column>
                <el-table-column prop="user_id" label="用户id" width="100"></el-table-column>
                <el-table-column prop="api" label="api"></el-table-column>
                <el-table-column prop="content" label="内容">
                    <template v-slot="scope">
                        <el-popover placement="top-start" width="500" trigger="click" :content="scope.row.content">
                            <template #reference>
                                <div class="custom-content">
                                    {{ scope.row.content }}
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="c_time" label="时间"></el-table-column>
            </el-table>
        </div>
        <div class="block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
                :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            pages: 1,
            limit: 10,
            deBugList: [],
            total: 0,
            dateValue: '',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            deBugCondition: '',
        }
    },
    created() {
        this.getDeBugList()
    },
    methods: {
        getDeBugList() {
            this.$get(`/v1/debug?pages=${this.pages}&limit=${this.limit}&date=${this.dateValue}&search=${this.deBugCondition}`, {}).then((res) => {
                let resultData = res.data
                this.total = resultData.total
                this.deBugList = resultData.data
            });
        },
        handleSizeChange(val) {
            console.log(val)
            this.limit = val;
            this.getDeBugList()
        },
        handleCurrentChange(val) {
            this.pages = val;
            this.getDeBugList()
        },
        handleDateChange(value) {
            // 用户选择日期后触发的方法
            const year = value.getFullYear();
            const month = value.getMonth() + 1; // 月份是从0开始的，所以需要加1
            const day = value.getDate();
            const selectedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
            this.dateValue = selectedDate
            console.log(this.dateValue)
        },
        Query() {
            this.pages = 1
            this.getDeBugList(); // 使用选择的日期发起请求
        },
        resetting() {
            this.pages = 1
            this.dateValue = ''
            this.deBugCondition = ''
            this.getDeBugList()
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 1) {
                return '';
            } else {
                return 'success-row';
            }
        },
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.flex_box{
    margin: 12px;
    text-align right
}

.flex_box div {
    margin 10px
}

.right_box div {
    margin 10px
}
.right_box{
    color: red;
}

.dialog_style{
    display flex
    align-items center
    justify-content center
    font-size 19px
    color #000
}

   .el-select .el-input {
      width: 200px;
    }
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  
      .el-table .success-row {
        background: #f0f9eb;
      }
  
      .search
        margin 20px 0
        display flex
        justify-content flex-start
        input
          width 220px
          margin-right 20px
        .add
          padding-left 100px
  
      .list
        min-height 550px
        border 1px solid #EBEEF5
        .edit_icon
          width 20px
          height 20px
          margin-left 16px
          border 1px solid  #ccc
          border-radius 4px
  
  </style>
<style scoped>
.custom-content {
    display: -webkit-box;
    /* 作为弹性盒子模型显示 */
    -webkit-box-orient: vertical;
    /* 设置弹性盒子主轴方向为垂直 */
    overflow: hidden;
    /* 隐藏超出内容 */
    text-overflow: ellipsis;
    /* 在内容超出时显示省略号（但此属性在此场景下可能不直接生效，由-webkit-line-clamp处理） */
    max-height: 100px;
    /* 设置最大高度，与行数限制共同决定最终显示效果 */
    line-height: normal;
}
</style>


// WEBPACK FOOTER //
// src/pages/deBug/deBug.vue